<template>
    <v-layout column>
        <v-layout wrap class="pr-2 pl-2">
            <v-flex sm12 md2>
                <label-results :count="state.count" />
            </v-flex>
            <v-flex text-sm-center sm12 md8>
                <pagination
                    v-model="pagingParam"
                    :total-visible="12"
                    :disabled="state.search.isProcessing || state.download.isProcessing"
                />
            </v-flex>
            <v-flex text-sm-right sm12 md2>
                <per-page-selector
                    v-model="pagingParam"
                    :disabled="state.search.isProcessing || state.download.isProcessing"
                />
            </v-flex>
        </v-layout>
        <v-layout class="pa-2">
            <v-flex xs12>
                <the-csv-list-table
                    :own-id="ownId"
                    :csv-lists="state.lists"
                    :csv-count="state.count"
                    :sort.sync="sort"
                    :processing="state.search.isProcessing || state.download.isProcessing"
                    :fetch-success="state.search.isFetchSuccess"
                    @download-start="downloadStart"
                    @download-success="downloadSuccess"
                    @download-failure="downloadFailure"
                />
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex text-center>
                <pagination
                    v-model="pagingParam"
                    :total-visible="12"
                    :disabled="state.search.isProcessing || state.download.isProcessing"
                />
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script lang="ts">
import Component, { mixins } from 'vue-class-component';
import { Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { SelectorFilterItems, LabelResults, Pagination, PerPageSelector } from '../../atoms';
import { TheCsvListTable, TheDeleteDialog } from '../../molecules';
import type { CsvListState, CsvListSortColumn } from '../../../store/modules/csv/types';
import SortParam from '../../../utils/types/SortParam';
import { PagingParam, mergePagingParam } from '../../../utils/types/PagingParam';
import { AppContext } from '../../../store/context';

@Component({
    name: 'TheCsvListPane',
    components: {
        SelectorFilterItems,
        TheCsvListTable,
        LabelResults,
        Pagination,
        PerPageSelector,
    },
})
export default class TheCsvListPane extends Vue {
    @Getter('id', { namespace: 'auth' }) id: any;
    @State('csv') state: CsvListState;
    @Action('search', { namespace: 'csv' }) search;
    @Action('downloadStart', { namespace: 'csv' }) downloadStart;
    @Action('downloadSuccess', { namespace: 'csv' }) downloadSuccess;
    @Action('downloadFailure', { namespace: 'csv' }) downloadFailure;

    sort = new SortParam<CsvListSortColumn>({
        column: 'created_at',
        direction: 'desc',
    });
    @Watch('sort', { deep: true })
    onSortChanged() {
        this.callSearch();
    }
    tableParam: PagingParam = {
        currentPage: 1,
        perPage: 10,
        total: 0,
    };
    @Watch('tableParam', { deep: true })
    onTableParamChanged() {
        this.callSearch();
    }

    /**
     * lifecycle hooks
     */
    async created() {
        this.callSearch();
    }

    /**
     * getter, setter
     */
    get ownId(): number {
        return this.id();
    }
    get pagingParam(): PagingParam {
        return mergePagingParam(this.tableParam, { total: this.state.count });
    }
    set pagingParam(newVal: PagingParam) {
        this.tableParam = newVal;
    }

    /**
     * methods
     */
    async callSearchPage(reload) {
        if (reload) {
            await this.reloadPage();
        } else {
            window.scrollTo(0, 0);
        }
    }
    async callSearch() {
        await (this as any).search({
            pageNumber: this.tableParam.currentPage,
            perPage: this.tableParam.perPage,
            sort: this.sort,
        });
    }
    async reloadPage() {
        this.tableParam.currentPage = 1;
        await this.callSearch();
    }
}
</script>
